import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import AdminNavbar from "../components/Navbar/AdminNavbar";
import AdminSidebar from "../components/Sidebar/AdminSidebar";
import Sidebar from "../components/Sidebar/Sidebar";
import { getRole } from "../components/Apicall";
import "./Layout.css";

const Layout = () => {
  const [userRole, setUserRole] = useState(null);
  const [vendorData, setVendorData] = useState();

  useEffect(() => {
    setUserRole(getRole());
  }, []);

  const renderSidebar =
    userRole === "3" ? (
      <Sidebar vendorData={vendorData} />
    ) : (
      <AdminSidebar />
    );

  const renderNavbar =
    userRole === "3" ? (
      <Navbar vendorDataPass={(data) => setVendorData(data)} />
    ) : (
      <AdminNavbar />
    );
return (
  <div className="layout-container">
    {renderNavbar}

    <div className="d-flex">

      {/* Desktop Sidebar */}
      <div className="sidebar-wrapper d-none d-md-block">
        {renderSidebar}
      </div>

      {/* Content */}
      <main className="content-area">
        <Outlet />
      </main>
    </div>

    {/* Mobile Bottom Sidebar */}
    <div className="mobile-bottom-nav d-block d-md-none">
      {renderSidebar}
    </div>
  </div>
);


};

export default Layout;
